import { Injectable, computed, inject } from '@angular/core';
import { UserStore } from '../../../core/store/user.store';
import {
  buildUserPermissionTree,
  type PermissionClusterTree,
} from '../models/permission-cluster.model';

/**
 * Reactive view of the logged-in user's permission tree: `UserStore.permissions()` is
 * refreshed by the login callback and by every token refresh, so this recomputes
 * automatically whenever the session changes — no manual re-derivation needed.
 */
@Injectable({ providedIn: 'root' })
export class UserPermissionTreeService {
  private readonly userStore = inject(UserStore);

  readonly tree = computed<PermissionClusterTree>(() =>
    buildUserPermissionTree(this.userStore.permissions())
  );

  /**
   * True if the user's role grants this exact permission code. Use it for a single
   * action (one API call, one button); sub-cluster checks on `tree` are too coarse
   * when several actions share an access type.
   */
  hasPermission(code: string): boolean {
    return this.userStore.permissions().includes(code);
  }
}
